export default __webpack_public_path__ + "static/media/trip.de8d0507.png";